(function () {
  function fetchSectionHtml(sectionId) {
    return fetch(`${window.routes.cart_url}?section_id=${sectionId}`).then((res) => res.text());
  }

  function refreshCartUI() {
    const targets = [
      { sectionId: 'main-cart-items', selector: '.js-contents' },
      { sectionId: 'main-cart-footer', selector: '.js-contents' },
      { sectionId: 'cart-icon-bubble', selector: '.shopify-section' },
    ];
    return Promise.all(
      targets.map((t) =>
        fetchSectionHtml(t.sectionId)
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const source = doc.querySelector(t.selector);
            const hostEl = document.getElementById(t.sectionId);
            if (!source || !hostEl) return;
            const target = hostEl.querySelector(t.selector) || hostEl;
            target.innerHTML = source.innerHTML;
          })
          .catch(() => {})
      )
    );
  }

  function postJson(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then((res) => {
      if (!res.ok) throw new Error('Fast Track request failed');
      return res.json();
    });
  }

  function removeFastTrackLine(container) {
    const lineKey = container.dataset.lineKey;
    const variantId = container.dataset.variantId;
    const itemTitle = container.dataset.itemTitle;
    const forLabel = container.dataset.forLabel;

    if (lineKey) {
      return postJson('/cart/change.js', { id: lineKey, quantity: 0 });
    }

    // Line key wasn't available on the rendered element — look it up before removing.
    return fetch('/cart.js')
      .then((res) => res.json())
      .then((cart) => {
        const match = cart.items.find(
          (li) => String(li.variant_id) === String(variantId) && li.properties && li.properties[forLabel] === itemTitle
        );
        if (!match) return null;
        return postJson('/cart/change.js', { id: match.key, quantity: 0 });
      });
  }

  function handleToggle(checkbox) {
    const container = checkbox.closest('[data-hz-fast-track]');
    if (!container) return;

    const variantId = container.dataset.variantId;
    const itemTitle = container.dataset.itemTitle;
    const forLabel = container.dataset.forLabel;

    container.classList.add('is-loading');

    const request = checkbox.checked
      ? postJson('/cart/add.js', {
          items: [{ id: variantId, quantity: 1, properties: { [forLabel]: itemTitle } }],
        })
      : removeFastTrackLine(container);

    request
      .then(() => refreshCartUI())
      .catch(() => {
        checkbox.checked = !checkbox.checked;
      })
      .finally(() => {
        container.classList.remove('is-loading');
      });
  }

  document.addEventListener('change', (event) => {
    if (event.target.matches('[data-hz-fast-track] input[type="checkbox"]')) {
      handleToggle(event.target);
    }
  });

  function renderRelatedProducts(container, products) {
    if (!products.length) return;
    const heading = container.dataset.heading || 'You might also like';
    const cards = products
      .slice(0, 3)
      .map((p) => {
        const image = p.featured_image || (p.images && p.images[0]) || '';
        return `<a class="hz-related-products__card" href="${p.url}">
          ${image ? `<img src="${image}" alt="" loading="lazy">` : ''}
          <span class="hz-related-products__card-title">${p.title}</span>
          <span class="hz-related-products__card-price">CHF ${(Number(p.price) / 100).toFixed(2)}</span>
        </a>`;
      })
      .join('');
    container.innerHTML = `<p class="hz-related-products__heading">${heading}</p><div class="hz-related-products__grid">${cards}</div>`;
  }

  function loadRelatedProducts(container) {
    if (container.dataset.hzRelatedLoaded === 'true') return;
    container.dataset.hzRelatedLoaded = 'true';
    const productId = container.dataset.productId;
    if (!productId) return;

    fetch(`/recommendations/products.json?product_id=${productId}&limit=3&intent=related`)
      .then((res) => res.json())
      .then((data) => renderRelatedProducts(container, (data && data.products) || []))
      .catch(() => {});
  }

  function scanForRelatedProducts(root) {
    root.querySelectorAll('[data-hz-related]').forEach(loadRelatedProducts);
  }

  const cartNotificationEl = document.getElementById('cart-notification');
  if (cartNotificationEl) {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && cartNotificationEl.classList.contains('active')) {
          scanForRelatedProducts(cartNotificationEl);
        }
      });
    });
    observer.observe(cartNotificationEl, { attributes: true, attributeFilter: ['class'] });
  }
})();
